<template>
  <div class="page-index template-index">
    <div class="toolbar-box">
      <el-popover
          placement="right"
          width="400"
          trigger="click">
        <el-form :model="form" label-width="30px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="上">
                <el-input type="number" v-model="form.padding.top"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="右">
                <el-input type="number" v-model="form.padding.right"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="下">
                <el-input type="number" v-model="form.padding.bottom"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="左">
                <el-input type="number" v-model="form.padding.left"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button class="btn-left" slot="reference">边距设置</el-button>
      </el-popover>

      <el-popover
          placement="right"
          width="300"
          trigger="click">
        <el-form :model="form" label-width="60px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="宽(mm)">
                <el-input type="number" v-model="form.page.width"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="高(mm)">
                <el-input type="number" v-model="form.page.height"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button class="btn-left" slot="reference">页面设置</el-button>
      </el-popover>
    </div>
    <div class="main-box" :style="{height: tableHeight + 20 + 'px'}">
      <div class="seting-box"></div>
      <div class="preview-box"
          :style="{
            width: form.page.width + 'mm' || 0,
            height: form.page.height + 'mm' || 0,
            overflow: 'hidden'
          }">
        <div :style="{
              paddingTop: form.padding.top + 'px' || 0,
              paddingRight: form.padding.right + 'px' || 0,
              paddingBottom: form.padding.bottom + 'px' || 0,
              paddingLeft: form.padding.left + 'px' || 0,
              overflow: 'hidden'
            }">
          <div class="flex">
            <div style="width:160px">
              <div style="font-size:1px;transform: scale(0.73);transform-origin: left;white-space: nowrap;">生产许可证：{{form.scxkz}}</div>
              <div style="font-size:1px;transform: scale(0.73);transform-origin: left;white-space: nowrap;">产品标准编号：{{form.cpbzbh}}</div>
              <div style="font-size:1px;transform: scale(0.73);transform-origin: left;white-space: nowrap;">产品批准文号：{{form.cppzwh}}</div>
            </div>
            <div>
              <div style="font-size:1px;transform: scale(0.7);transform-origin: left;white-space: nowrap;">产品符合饲料卫生标准</div>
              <div style="font-size:1px;transform: scale(1);transform-origin: left;white-space: nowrap;font-weight: bold;">{{form.productName}}</div>
            </div>
          </div>
          <div class="flex" style="align-items: center;font-size:12px">
            <div>生产日期：</div>
            <div class="flex-1" style="text-align:center;font-weight: bold;font-size:16px">{{form.productDate}}</div>
            <div>(年/月/日)</div>
          </div>
          <div style="font-weight: 600;font-size: 22px;text-align:center;">{{form.type}}</div>
          <div style="font-size:1px;transform: scale(0.8);transform-origin: center;white-space: nowrap;text-align: center">饲喂阶段：{{form.stage}}</div>
          <div style="font-size:1px;transform: scale(0.8);transform-origin: left;white-space: nowrap;">产品成分分析保证值：（每千克本品中含量）</div>
          <div>
            <table border="1" cellspacing="0" style="width:100%">
              <tr>
                <td>VA(万IU)</td>
                <td>≥4.4</td>
                <td>铜(g)</td>
                <td>≥0.08</td>
              </tr>
              <tr>
                <td>VA(万IU)</td>
                <td>≥4.4</td>
                <td>铜(g)</td>
                <td>≥0.08</td>
              </tr>
              <tr>
                <td>VA(万IU)</td>
                <td>≥4.4</td>
                <td>铜(g)</td>
                <td>≥0.08</td>
              </tr>
              <tr>
                <td>VA(万IU)</td>
                <td>≥4.4</td>
                <td>铜(g)</td>
                <td>≥0.08</td>
              </tr>
              <tr>
                <td>VA(万IU)</td>
                <td>≥4.4</td>
                <td>铜(g)</td>
                <td>≥0.08</td>
              </tr>
            </table>
          </div>
          <div>使用说明：</div>
          <div><textarea readonly="readonly" v-model="form.instructions"></textarea></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'

  export default {
    mixins: [tableMixin],
    name: 'template-index',
    data() {
      return {
        dialogVisible: false,
        form: {
          scxkz: '苏饲预(2019)05001',
          cpbzbh: 'Q/320585 ATV 10-2019',
          cppzwh: '苏饲预字(2017)272707',
          productName: '六六大顺1016',
          productDate: '2020/06/05',
          type: '哺乳母猪复合预混合饲料',
          stage: '产前30天至分娩、哺乳全期',
          instructions: '1、测试',
          padding: {
            top: 10,
            right: 10,
            bottom: 10,
            left: 10
          },
          page: {
            width: 70,
            height: 120
          }
        }
      }
    },
    created() {
    },
    activated() {},
    methods: {
      openModel() {
        this.dialogVisible = true
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.template-index
    .toolbar-box
      display flex
      margin 10px 0
      .btn-left
        background #A5CE1C
        color #fff
        margin-right 20px
    .main-box
      display flex
      .seting-box, .preview-box
        background-color #fff
      .seting-box
        flex 1
        padding 20px
        margin-right 20px
      .preview-box
        width 100%
        .flex
          display flex
        .flex-1
          flex 1
  .el-col
      .el-form-item
        margin-bottom 0
</style>
